import { dbTableCampaign } from "@dataseat-dsp-client/lib-reporter";

export const getBorMeasureExpr = dbTableCampaign.getBorMeasureExpr;
export const getCohortedBorMeasureExpr =
  dbTableCampaign.getCohortedBorMeasureExpr;
